import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchNotifications, markNotificationsRead } from './api';

const DEFAULT_POLL_MS = 30000;

/**
 * The bell's feed. Polled — there is no push channel in this app yet (see
 * backend/utils/notifications/providers/push.js). The server says how often
 * (`poll_seconds`), so the cadence can change without a release.
 */
export function useStaffNotifications() {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.notifications.feed(), branchVersion],
    queryFn: fetchNotifications,
    refetchInterval: (q) => (q.state.data?.poll_seconds ? q.state.data.poll_seconds * 1000 : DEFAULT_POLL_MS),
  });
}

export function useInvalidateNotifications() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: keys.notifications.feed() });
}

export function useMarkNotificationsRead() {
  const invalidate = useInvalidateNotifications();
  return useMutation({ mutationFn: markNotificationsRead, onSuccess: invalidate });
}
